export enum PresentationSlot {
  Playlist = 'playlist',
  Overlay = 'overlay',
  Interrupt = 'interrupt'
}
